import { Product } from '@axo/shared/data-access/types';
import { ApplicantDataApplicantTabPanelSection } from '../ApplicationDataApplicantTabPanelLayout';
import { MarketCountryCode } from '@axo/shared/data-access/types/ace_index';
import { ApplicationConditionalWrapper } from '../../../ConditionalWrappers/ApplicationConditionalWrapper';
import { ApplicationDataCurrencyField } from '../../Fields/ApplicationDataCurrencyField';

interface ConsumptionSectionProps {
  applicationID: string;
}

export const ConsumptionSection: React.FC<ConsumptionSectionProps> = ({
  applicationID,
}) => {
  return (
    <ApplicantDataApplicantTabPanelSection title="Consumption">
      <ApplicationConditionalWrapper
        whitelist={[
          {
            marketCountry: [MarketCountryCode.Denmark],
            productType: [Product.UnsecuredLoan],
          },
        ]}
      >
        <ApplicationDataCurrencyField
          applicationID={applicationID}
          name="ExpensesPhoneInternetTV"
          label="Phone, Internet, TV"
        />
        <ApplicationDataCurrencyField
          applicationID={applicationID}
          name="ExpensesTransport"
          label="Transport"
        />
        <ApplicationDataCurrencyField
          applicationID={applicationID}
          name="ExpensesElectricity"
          label="Electricity"
        />
        <ApplicationDataCurrencyField
          applicationID={applicationID}
          name="ExpensesWater"
          label="Water"
        />
        <ApplicationDataCurrencyField
          applicationID={applicationID}
          name="ExpensesHeating"
          label="Heating"
        />
        <ApplicationDataCurrencyField
          applicationID={applicationID}
          name="ExpensesInsurances"
          label="Insurances"
        />
      </ApplicationConditionalWrapper>
    </ApplicantDataApplicantTabPanelSection>
  );
};
